function quantitychangeEvent() 
{
    var quantitySelectbox =    document.querySelector('.selectbox_quantity__input')
    var old_quantity__input =    document.querySelector('.old_quantity__input')
    if( quantitySelectbox && old_quantity__input )
    {
        quantitySelectbox.addEventListener('change', function() 
        {
            old_quantity__input.value = this.value;
        });
    }
}

function initProductSliderCustomArrows() 
{
    var custom_arrows = document.querySelector('.custom-arrows')
    
    
    if (custom_arrows != null) 
    {
        var custom_slider_buttons = custom_arrows.querySelectorAll( '.custom-slider-button' )
        custom_slider_buttons.forEach( custom_slider_button => 
        {
            custom_slider_button.addEventListener( 'click' , function( event ) 
            {
                var active_slide_number = parseInt( document.querySelector( '.thumbnail[aria-current="true"]' ).dataset.mediaPosition );
                
                if( event.currentTarget.name === 'custom-next' ) 
                {
                    var goto_slide_number = active_slide_number + 1;
                }   
                else
                {
                    var goto_slide_number = active_slide_number - 1;
                }
                var next_slide = document.querySelector( '[data-media-position="'+goto_slide_number+'"] .thumbnail' );
                next_slide.dispatchEvent( new Event('click') );
            });         
        });
        
    }
}

function initPlayPausedVideo(screen)
{
    var wrapper = document.querySelector( ".video_wrapper" );
    if( wrapper )
    {
        if( screen == "mobile" && document.querySelector( ".video_wrapper .mobile_video" ) )
        {
            var video = document.querySelector( ".video_wrapper .mobile_video" );
        }
        else
        {
            var video = document.querySelector( ".video_wrapper .desktop_video" );
        }
    
        if( video.paused )
        {
            video.play();
        }
    }
}

window.addEventListener("load", (event) => 
{
    quantitychangeEvent();
    initProductSliderCustomArrows();
});

window.addEventListener("DOMContentLoaded", (event) => 
{
    if( screen.width > 768 )
    {
        initPlayPausedVideo( "desktop" );
    }
    else
    {
        initPlayPausedVideo( "mobile" );
    }
});

window.addEventListener("resize", (event) => 
{
    if( screen.width > 768 )
    {
        initPlayPausedVideo( "desktop" );
    }
    else
    {
        initPlayPausedVideo( "mobile" );
    }
});